import { render, staticRenderFns } from "./StateHistory.vue?vue&type=template&id=969a20b4&"
import script from "./StateHistory.vue?vue&type=script&lang=js&"
export * from "./StateHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports